import React from 'react'
import { Link } from 'react-router-dom'
import Third_pane from '../../ValleyCourt2/Blocks/Third_pane'
import boiteAzureBg from './../../../images/boiteAzureBg.jpg'
import gray_dots from './../../../images/gray_dots.jpg'

import homebox from './../../../images/home-box.png'


import new1 from './../../../images/new1.png'

import new2 from './../../../images/new2.jpg'

import new3 from './../../../images/new3.jpg'

import new4 from './../../../images/new4.jpg'

import new5 from './../../../images/new5.jpg'

import new6 from './../../../images/new6.jpg'

import new7 from './../../../images/new7.jpg'

import new8 from './../../../images/new8.jpg'
import biote_zure from '../../../images/biote_zure.png'
import biote_pan from '../../../images/biote_pan.png'

import BA2 from '../../../images/BA2.jpg'
import BA3 from '../../../images/BA3.jpg'
import BA4 from '../../../images/BA4.jpg'
import BA5 from '../../../images/BA5.jpg'
import BA6 from '../../../images/BA6.jpg'
import BA7 from '../../../images/BA7.jpg'
import BA8 from '../../../images/BA8.jpg'
import BA9 from '../../../images/BA9.jpg'
import BA10 from '../../../images/BA10.jpg'
import BA11 from '../../../images/BA11.jpg'
import BA12 from '../../../images/BA12.jpg'
import BA13 from '../../../images/BA13.jpg'
import BA14 from '../../../images/BA14.jpg'
import BA15 from '../../../images/BA15.jpg'
import BA16 from '../../../images/BA16.jpg'





const First_Pane = () => 
(
    <div>
        
        <div 
            style={{ backgroundImage: `url(${boiteAzureBg})`,
            backgroundRepeat: 'no-repeat',
            backgroundSize: 'cover',
            paddingBottom: '50px',
            paddingTop: '100px',
            height: '95vh'
        }}

        >
            <div className='uk-container uk-margin-xlarge-top'>
                <div className='uk-grid'>
                    <div className='uk-width-1-2@s'>

                    <h1 className='light uk-text-bold header1'>Boite Azure </h1>
                    <h5 className='light'>
                        Welcome to Boîte Azure, a thoughtfully designed residential development
                         created for individuals and families who value comfort, security, and 
                         contemporary living. Every detail is carefully crafted to deliver a 
                         refined lifestyle in a serene and well-planned environment.
                    </h5>
                    </div>

                    <div className='uk-width-1-2@s'>
 
                    </div>
                </div>


               


            </div>
           
          
        </div>


         

                   
                   
                   <div
                    style={{ backgroundImage: `url(${gray_dots})`,
                    backgroundRepeat: 'no-repeat',
                    backgroundSize: 'cover',
                    paddingBottom: '50px',
                    paddingTop: '100px',
                    height: '100vh'
                }} >


                       <div className='uk-container'>
                           <div className='uk-grid uk-grid-collapse' data-uk-grid>
                                <div className='uk-width-1-2@s'>
                                    <div 
                                    style={{ backgroundImage: `url(${BA15})`,
                                    backgroundRepeat: 'no-repeat',
                                    backgroundSize: 'cover',
                                    paddingBottom: '50px',
                                    paddingTop: '100px',
                                    height: '90vh'
                                }}
                                    
                                    >

                                    </div>
                                </div>

                                <div className='uk-width-1-2@s'>
                                    <div 
                                         style={{ backgroundImage: `url(${homebox})`,
                                         backgroundRepeat: 'no-repeat',
                                         backgroundSize: 'cover',
                                         paddingBottom: '50px',
                                         paddingTop: '100px',
                                         height: '90vh'
                                     }} >

                                         <div className='uk-padding'>
                                            <h4 className='light'>About Boîte Azure</h4>
                                             <p className='light'>

                                                Boîte Azure is more than a housing project — it is a 
                                                community designed to offer peace of mind, modern 
                                                architecture, and long-term value. Located in a strategic 
                                                and accessible area, the estate combines elegant design with 
                                                functional living spaces to meet today’s lifestyle needs.
                                             </p>

                                               <p className='light'>
                                                Whether you are buying your first home, upgrading your lifestyle, 
                                                or investing for the future, Boîte Azure offers homes that truly 
                                                stand out.
                                               </p>
                                         </div>

                                        

                                    </div>
                                </div>
                           </div>
                       </div>
                   </div>


                   <Third_pane />

                  
                        <div className='uk-container'>
                        <div className='uk-margin-small-top'>


                       <div className='row'>
                            <div className='col-sm-4'>
                                <img 
                                    src={BA2} 
                                    alt="Dynamic content" 
                                    style={{ 
                                        width: '100%', 
                                        height: 'auto', 
                                        display: 'block' 
                                    }} 
                                />
                            </div>

                            <div className='col-sm-4'>
                                  <img 
                                    src={BA3} 
                                    alt="Dynamic content" 
                                    style={{ 
                                        width: '100%', 
                                        height: 'auto', 
                                        display: 'block' 
                                    }} 
                                />
                            </div>


                            <div className='col-sm-4'>
                                <img 
                                    src={BA8} 
                                    alt="Dynamic content" 
                                    style={{ 
                                        width: '100%', 
                                        height: 'auto', 
                                        display: 'block' 
                                    }} 
                                />
                            </div>
                       </div>







                      <div className='row uk-margin-small-top'>
                            <div className='col-sm-4'>
                                <img 
                                    src={BA5} 
                                    alt="Dynamic content" 
                                    style={{ 
                                        width: '100%', 
                                        height: 'auto', 
                                        display: 'block' 
                                    }} 
                                />
                            </div>

                            <div className='col-sm-4'>
                                  <img 
                                    src={BA6} 
                                    alt="Dynamic content" 
                                    style={{ 
                                        width: '100%', 
                                        height: 'auto', 
                                        display: 'block' 
                                    }} 
                                />
                            </div>


                            <div className='col-sm-4'>
                                <img 
                                    src={BA7} 
                                    alt="Dynamic content" 
                                    style={{ 
                                        width: '100%', 
                                        height: 'auto', 
                                        display: 'block' 
                                    }} 
                                />
                            </div>
                       </div>







                      <div className='row uk-margin-small-top'>
                            <div className='col-sm-4'>
                                <img 
                                    src={BA4} 
                                    alt="Dynamic content" 
                                    style={{ 
                                        width: '100%', 
                                        height: 'auto', 
                                        display: 'block' 
                                    }} 
                                />
                            </div>

                            <div className='col-sm-4'>
                                  <img 
                                    src={BA9} 
                                    alt="Dynamic content" 
                                    style={{ 
                                        width: '100%', 
                                        height: 'auto', 
                                        display: 'block' 
                                    }} 
                                />
                            </div>


                            <div className='col-sm-4'>
                                <img 
                                    src={BA10} 
                                    alt="Dynamic content" 
                                    style={{ 
                                        width: '100%', 
                                        height: 'auto', 
                                        display: 'block' 
                                    }} 
                                />
                            </div>
                       </div>





 <div className='row uk-margin-small-top'>
                            <div className='col-sm-4'>
                                <img 
                                    src={BA11} 
                                    alt="Dynamic content" 
                                    style={{ 
                                        width: '100%', 
                                        height: 'auto', 
                                        display: 'block' 
                                    }} 
                                />
                            </div>

                            <div className='col-sm-4'>
                                  <img 
                                    src={BA12} 
                                    alt="Dynamic content" 
                                    style={{ 
                                        width: '100%', 
                                        height: 'auto', 
                                        display: 'block' 
                                    }} 
                                />
                            </div>


                            <div className='col-sm-4'>
                                <img 
                                    src={BA13} 
                                    alt="Dynamic content" 
                                    style={{ 
                                        width: '100%', 
                                        height: 'auto', 
                                        display: 'block' 
                                    }} 
                                />
                            </div>
                       </div>




 <div className='row uk-margin-small-top'>
                            <div className='col-sm-4'>
                                <img 
                                    src={BA14} 
                                    alt="Dynamic content" 
                                    style={{ 
                                        width: '100%', 
                                        height: 'auto', 
                                        display: 'block' 
                                    }} 
                                />
                            </div>

                            <div className='col-sm-4'>
                                  <img 
                                    src={BA15} 
                                    alt="Dynamic content" 
                                    style={{ 
                                        width: '100%', 
                                        height: 'auto', 
                                        display: 'block' 
                                    }} 
                                />
                            </div>


                            <div className='col-sm-4'>
                                <img 
                                    src={BA16} 
                                    alt="Dynamic content" 
                                    style={{ 
                                        width: '100%', 
                                        height: 'auto', 
                                        display: 'block' 
                                    }} 
                                />
                            </div>
                       </div>













                       </div>
                       </div>
















                



                   <div className='container uk-margin-large-top'>
                            
                            <div className='uk-margin-top uk-margin-bottom'>
                                <h2 className='uk-text-center uk-text-bold'>Boite Azure Realizations</h2>
                            </div>

                       <div className='row'>
                           <div className='col-sm-8'>
                                   <div
                                   style={{ backgroundImage: `url(${new2})`,
                                   backgroundRepeat: 'no-repeat',
                                   backgroundSize: 'cover',
                                   paddingBottom: '50px',
                                   paddingTop: '100px',
                                   height: '60vh'
                               }} >

                                </div>
                               </div>

                           <div className='col-sm-4'>
                                     <div
                                     style={{ backgroundImage: `url(${new2})`,
                                     backgroundRepeat: 'no-repeat',
                                     backgroundSize: 'cover',
                                     paddingBottom: '50px',
                                     paddingTop: '100px',
                                     height: '60vh'
                                 }}>
                           </div>
                                  </div>
                       </div>





                        <div className='uk-margin-small-top'>
                       <div className='row'>
                            <div className='col-sm-4'>
                                <div
                                    style={{ backgroundImage: `url(${new3})`,
                                    backgroundRepeat: 'no-repeat',
                                    backgroundSize: 'cover',
                                    paddingBottom: '50px',
                                    paddingTop: '100px',
                                    height: '60vh'
                                }}
                                >

                                </div>
                            </div>

                            <div className='col-sm-4'>
                                <div
                                   style={{ backgroundImage: `url(${new4})`,
                                   backgroundRepeat: 'no-repeat',
                                   backgroundSize: 'cover',
                                   paddingBottom: '50px',
                                   paddingTop: '100px',
                                   height: '60vh'
                               }}
                                >

                                </div>
                            </div>


                            <div className='col-sm-4'>
                                <div
                                  style={{ backgroundImage: `url(${new5})`,
                                  backgroundRepeat: 'no-repeat',
                                  backgroundSize: 'cover',
                                  paddingBottom: '50px',
                                  paddingTop: '100px',
                                  height: '60vh'
                              }}
                                
                                >

                                </div>
                            </div>
                       </div>
                       </div>
























                      <div className='uk-margin-small-top'>
                       <div className='row'>
                            <div className='col-sm-6'>
                                 <div
                                      style={{ backgroundImage: `url(${new6})`,
                                      backgroundRepeat: 'no-repeat',
                                      backgroundSize: 'cover',
                                      paddingBottom: '50px',
                                      paddingTop: '100px',
                                      height: '60vh'
                                  }}
                                 >

                                 </div>
                            </div>


                            <div className='col-sm-6'>
                            <div
                                      style={{ backgroundImage: `url(${new7})`,
                                      backgroundRepeat: 'no-repeat',
                                      backgroundSize: 'cover',
                                      paddingBottom: '50px',
                                      paddingTop: '100px',
                                      height: '60vh'
                                  }}
                                 >

                                 </div>
                            </div>
                       </div>
                       </div>

                   </div>




       {/*Next pane*/}
       <div className="uk-margin-large-top">
                 <div className=""
                 style={{ backgroundImage: `url(${gray_dots})`,
                 backgroundRepeat: 'no-repeat',
                 backgroundSize: 'cover',
                 paddingBottom: '50px',
               
                 height: '70vh'
                 }}>
                <div className="uk-grid" data-uk-grid>
                     <div className="uk-width-1-2@s">
                       <div className="uk-container uk-margin-large-top ">

                           <div className="uk-grid" data-uk-grid>
                              <div className="uk-width-1-5@s">

                              </div>


                              <div className="uk-width-3-5@s">
                              <h1 className="uk-text-bold uk-text-left light uk-padding">Let’s sit down
                               and talk about
                                 your new home</h1>
                              </div>


                              <div className="uk-width-1-5@s">

                              </div>


                           </div>




                           <div className="uk-grid" data-uk-grid>
                              <div className="uk-width-1-5">

                              </div>


                              <div className="uk-width-3-5">
                            <Link to="/contact"><p className="header1 uk-text-left light uk-padding">Contact Us
                               </p>  </Link>
                              </div>


                              <div className="uk-width-1-5">

                              </div>


                           </div>



                      
                           </div>
                     </div>


                     <div className="uk-width-1-2@s">
                       <div
                         style={{ backgroundImage: `url(${new7})`,
                         backgroundRepeat: 'no-repeat',
                         backgroundSize: 'cover',
                        
                       
                         height: '70vh'
                         }}
                       
                       >



                        </div>
                     </div>
                </div>
                </div>
             </div>



        


      


        






        
    </div>
  )


export default First_Pane